module.exports = __webpack_public_path__ + "static/media/welding-power-distribution.0d5fb30a.jpg";